import { Input, InputProps, forwardRef } from '@chakra-ui/react'

interface ITextInputProps extends InputProps {
  isDisabled?: boolean
  // code?: string
}

const TextInput = forwardRef((props: ITextInputProps, ref) => {
  const { isDisabled = false, type = 'text', ...rest } = props

  return (
    <Input
      fontWeight={'normal'}
      _hover={isDisabled ? {} : { borderColor: 'primary.300' }}
      _focusVisible={isDisabled ? {} : { borderWidth: '1.5px', borderColor: 'primary.600' }}
      borderRadius='4'
      bg={isDisabled ? '#EBECEC' : ''}
      type={type}
      color={'#000'}
      _placeholder={isDisabled ? { color: '#000' } : {}}
      isDisabled={isDisabled}
      className='input-text'
      onInput={(e) => {
        const malitiousPattern = [
          /<script/gi,
          /<iframe/gi,
          /<object/gi,
          /<embed/gi,
          /<applet/gi,
          /javascript:/gi,
        ]
        malitiousPattern.forEach((reg) => {
          if (reg.test(e.currentTarget.value)) {
            e.currentTarget.value = ''
          }
        })
      }}
      ref={ref}
      {...rest}
    />
  )
})

export { TextInput }
